import React, { useEffect, useRef, useState } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import FLEX from '@cybersource/flex-sdk-web';
import Label from "components/Label/Label";
import Input from "shared/Input/Input";
import Select from "shared/Select/Select";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import axios from "axios";
import toast from "react-hot-toast";

declare global {
    interface Window {
        Flex:any;
    }
}


// Define the props for the component
interface PaymentFormProps {
  // The URL of your server that provides the capture context
  captureContextUrl: string;
  // The callback function to handle the payment token
  onToken: (token: any) => void;
  // The callback function to handle any errors
  onError: (error: any) => void;
}

// Define the component
const CardForm: React.FC<PaymentFormProps> = ({
  captureContextUrl,
  onToken,
  onError,
}) => {
  // Create a ref to store the microform instance
  const microformRef = useRef<any>(null);

  // Create a state to store the values
  const [securityCodeInput, setSecurityCodeInput] =useState("");
  const [cardNumberInput, setCardNumberInput] =useState("");
  const [cardExpirationMonth, setCardExpirationMonth] =useState("");
  const [cardExpirationYear, setCardExpirationYear] =useState("");
  const [cardType, setCardType] =useState("")

  // Create a state to store the loading status
  const [loading, setLoading] = useState<boolean>(false);

  // Define a function to initialize the microform
 /* const initMicroform = async () => {
    try {
      // Set loading to true
      setLoading(true);



      // Get the capture context from your server
      let headers = new Headers();

      const response = await fetch(captureContextUrl).then((response) => response.json())
    
      let captureContext = ""
      if (response){
        console.log(response)
        captureContext = response;
      }
     

      // Create a new Flex instance with the capture context
      const flex = new window.Flex(captureContext);

      // Create a new Microform instance with some options
      const microform = flex.microform({
        styles: {
          input: {
            color: "#3a3a3a",
            backgroundColor: "#245f",
          },
          ":focus": {
            color: "blue",
          },
          ":disabled": {
            cursor: "not-allowed",
          },
          valid: {
            color: "#3c763d",
          },
          invalid: {
            color: "#a94442",
          },
        },
      });

      // Store the microform instance in the ref
      microformRef.current = microform;

      // Create and mount the card number input element
      const cardNumberElement = microform.createField("number", {
        placeholder: "Enter card number",
      });
      cardNumberElement.load("#card-number-container");
      setCardNumberInput(cardNumberElement.element);

      // Create and mount the security code input element
      const securityCodeElement = microform.createField("securityCode", {
        placeholder: "CVC",
      });
      securityCodeElement.load("#security-code-container");
      setSecurityCodeInput(securityCodeElement.element);

      // Set loading to false
      setLoading(false);
    } catch (error) {
      // Handle any errors
      console.error(error);
      onError(error);
    }
  };*/

  // Define a function to handle the form submission
  /*const handleSubmit = async () => {
    try {
      // Prevent default form behavior
      
      //event.preventDefault();

      // Set loading to true
      setLoading(true);

      // Get the microform instance from the ref
      const microform = microformRef.current;

      // Tokenize the card data using the microform instance
      const result = await microform.createToken();

        // Check if tokenization succeeded
        if (typeof result !=="undefined" && result.status === "success") {
          // Get the token from the result
          const token = result.token;
  
          // Pass the token to the callback function
          onToken(token);
        } else {
          // Handle any errors
          console.error(result.reason);
          onError(result.reason);
        }
      } catch (error) {
        // Handle any errors
        console.error(error);
        onError(error);
      } finally {
        // Set loading to false
        setLoading(false);
      }
    };*/
  
    const handleSubmit = async ()=>{
      
      const captureContext = await toast.promise(
        axios.get(captureContextUrl), // this returns a promise
        {
          loading: "Fetching capture context...",
          success: (response) => `Capture context fetched: ${response.data.kid}`,
          error: (error) => `Error fetching capture context: ${error}`,
        }
      );

      console.log({cardNumberInput, cardType, cardExpirationMonth, cardExpirationYear})
      const options = {
        kid: captureContext.data.kid,
        keystore: captureContext.data,
        encryptionType: 'RsaOaep256', // ensure this matches the encryptionType you specified when creating your key
        cardInfo: {
          cardNumber: cardNumberInput,
          cardType: cardType,
          cardExpirationMonth: cardExpirationMonth,
          cardExpirationYear: cardExpirationYear
        }
      };
      
      const tokenPromise = new Promise((resolve, reject) => {
        FLEX.createToken(options, (response: any) => {
          if (response.error) {
            reject(response.error);
          } else {
            resolve(response.token);
          }
          console.log(response.token);
        });
      });

      // use toast.promise to show a notification based on the promise status
      toast.promise(tokenPromise, {
        loading: "Creating token...",
        success: (token) => `Token created: ${token}`,
        error: (error) => `Error creating token: ${error}`,
      });

      // use the tokenPromise as you wish
      tokenPromise.then((token) => {
        console.log(token);
        onToken(token);
      });

    }
    
    // Use an effect hook to initialize the microform when the component mounts
    /*useEffect(() => {
      initMicroform();
    }, []);*/
  
    // Return the JSX element for the payment form
    return (
        <>
          <div className="space-y-1">
            <Label>Card number </Label>
            <Input value={cardNumberInput} placeholder="0000 0000 0000 0000" onChange={(e)=> setCardNumberInput(e.target.value)} minLength={19} maxLength={19} />
          </div>
          <div className="space-y-1">
            <Label>Card Type</Label>
            <Select onChange={(e: React.ChangeEvent<HTMLSelectElement>)=>{setCardType(e.target.value)}}>
              <option value="001" defaultChecked>Visa</option>
              <option value="002">Mastercard</option>
              <option value="003">AMEX</option>
            </Select>
          </div>
          <div className="flex space-x-5  ">
            <div className="flex-1 space-y-1">
              <Label>Month </Label>
              <Input placeholder="MM" onChange={(e)=> setCardExpirationMonth(e.target.value)} minLength={2} maxLength={2}/>
            </div>
            <div className="flex-1 space-y-1">
              <Label>Year</Label>
              <Input placeholder="YYYY" onChange={(e)=> setCardExpirationYear(e.target.value)} minLength={4} maxLength={4}/>
            </div>
            <div className="flex-1 space-y-1">
              <Label>CVC </Label>
                <Input placeholder="000" onChange={(e)=> setSecurityCodeInput(e.target.value)} minLength={3} maxLength={3}/>
            </div>
          </div>
          <div className="pt-8">
              <ButtonPrimary onClick={handleSubmit}>Confirm and pay</ButtonPrimary>
          </div>
        </>
    );
};
      
export default CardForm;